import Vue from 'vue';

export default {
  setData(state, data) {
    Vue.set(state, 'data', data);
  },
  setSeriesData(state, data) {
    Vue.set(state, 'seriesData', data);
  },
  setVideos(state, data) {
    Vue.set(state, 'videos', data);
  },
  setSeriesVideos(state, videos) {
    Vue.set(state, 'currentSeriesVideos', videos);
  },
  setLoadStatus(state, isLoading) {
    Vue.set(state, 'isLoading', isLoading);
  },
  toggleTeachersModal(state, show) {
    Vue.set(state, 'showTeachers', show);
  },
  addTeacher(state, tid) {
    state.teacherSort.push(tid);
  },
  removeTeacher(state, tid) {
    let i = state.teacherSort.indexOf(tid);
    state.teacherSort.splice(i, 1);
  },
};
